import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DevicesRouterStoreSelectors } from '@era/stores';
import { Dictionary } from '@ngrx/entity';
import * as fromAllowedOsUpdates from './allowed-os-updates.reducer';
import { allowedOsUpdateFeatureKey } from './allowed-os-updates.reducer';
import { AllowedOsUpdate, AllowedOsUpdateState } from './allowed-os-updates.state';

export const selectAllowedOsUpdatesState = createFeatureSelector<AllowedOsUpdateState>(allowedOsUpdateFeatureKey);

export const selectAllAllowedOsUpdates = createSelector(
  selectAllowedOsUpdatesState,
  fromAllowedOsUpdates.selectAllAllowedOsUpdates
);
export const selectAllAllowedOsUpdatesIds = createSelector(
  selectAllowedOsUpdatesState,
  fromAllowedOsUpdates.selectAllowedOsUpdateIds,
  (_, ids) => ids as string[]
);

export const selectAllAllowedOsUpdatesEntities = createSelector(
  selectAllowedOsUpdatesState,
  fromAllowedOsUpdates.selectAllowedOsUpdateEntities
);

export const selectAllowedOsUpdateIdsForCurrentDevice = createSelector(
  selectAllAllowedOsUpdatesIds,
  DevicesRouterStoreSelectors.selectUdid,
  (updates: string[], udid: string) => (updates ? updates.filter((x) => x.startsWith(udid)) : [])
);

export const selectIsCurrentDeviceAtLatestAllowedOsVersion = createSelector(
  selectAllAllowedOsUpdatesEntities,
  selectAllowedOsUpdateIdsForCurrentDevice,
  (updates: Dictionary<AllowedOsUpdate>, ids: string[]) => {
    const values: AllowedOsUpdate[] = [];
    for (const id of ids) {
      const update = updates[id];
      if (update) {
        values.push(update);
      }
    }
    return values.length === 0;
  }
);
